import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import DiscountFormSettings from "./discount-settings-form";

export default function DiscountFormCard() {
  const discountPreferences = useCurrentShopSuspense().data.discount;

  if (!discountPreferences) return null;

  return (
    <DiscountFormSettings
      defaultValues={{
        activated: discountPreferences.activated,
        discount_bonus: {
          amount: discountPreferences.discount_bonus?.amount,
          type: discountPreferences.discount_bonus?.type,
        },
        discountAcceptedCountries:
          discountPreferences.discountAcceptedCountries,
        tagsForNotAcceptedDiscount:
          discountPreferences.tagsForNotAcceptedDiscount,
        minimalDiscountForFreeShipping:
          discountPreferences.minimalDiscountForFreeShipping,
        discountFreeShippingActivated:
          discountPreferences.discountFreeShippingActivated,
        freeShippingCode: discountPreferences?.freeShippingCode ?? "",
        giftCard: discountPreferences?.giftCard,
        applyReturnShippingFeesForDiscountRule:
          discountPreferences?.applyReturnShippingFeesForDiscountRule,
        validity: discountPreferences.validity,
        codesToIgnoreRegex: discountPreferences.codesToIgnoreRegex || undefined,
      }}
    />
  );
}
